import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=4c244a22&scoped=true&"
import script from "./TaskManager.vue?vue&type=script&lang=js&"
export * from "./TaskManager.vue?vue&type=script&lang=js&"
import style0 from "./TaskManager.vue?vue&type=style&index=0&id=4c244a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c244a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VIcon,VRadio,VRadioGroup})
